module.exports = __webpack_public_path__ + "img/d-p-03.616c48a1.png";